import { useLang } from '../i18n';

export function LangToggle() {
  const { lang, setLang } = useLang();
  return (
    <span className="langtoggle" role="group" aria-label="Language">
      <button className={lang === 'en' ? 'on' : ''} onClick={() => setLang('en')}>EN</button>
      <button className={lang === 'uk' ? 'on' : ''} onClick={() => setLang('uk')}>UA</button>
    </span>
  );
}
